import getName from '../../../../../helpers/getName';

export const generateCreateUsers = (map) => (request) => {
  const { createUser } = request;
  const id = createUser?.id || 0;

  const entity = map.get(id) || {
    name: createUser ? getName(createUser) : 'Не указан',
    amount: 0,
    speciality: createUser?.speciality,
    id,
  };

  entity.amount += 1;

  map.set(id, entity);
};
